
export default {
  props: {
    onClick: {
      type: Function,
      default: () => {},
    },
    size: { type: String, default: '' },
    bold: { type: Boolean, default: false },
    type: { type: String, default: '' },
  },
  computed: {
    smallStyle() {
      return {
        small: this.size === 'small',
        xsmall: this.size === 'xsmall',
        medium: this.size === 'medium',
        bold: this.bold,
        secondary: this.type === 'secondary',
      };
    },
  },
};
